/* FRILLORA-GALLERY-ALL-IMAGES-ZOOM-20261031-v1 */
/* FRILLORA-PDP-TAP-ZOOM-LOCALES-v1 */
(() => {
  'use strict';
  if (window.FrilloraPdpInspect) { window.FrilloraPdpInspect.init(); return; }
  const SELECTOR = '[data-pdp-main-image], .fr-naked-gallery-frame [data-fr-naked-zoom] img';
  const ZOOM = 2.5;
  const TAP_MS = 500;
  const MOVE_LIMIT = 10;
  const bindings = new Map();
  let state = null;
  let dismissedPress = null;
  let panel, stage, closeButton, sequence = 0;
  const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
  const number = value => parseFloat(value) || 0;
  const defaults = {
    zoomHint: 'Press and hold to inspect',
    mobileZoomHint: 'Tap to zoom. Drag the enlarged image to explore.',
    closeLabel: 'Close zoom',
    zoomImageLabel: 'Inspect product image',
    zoomKeyboardHint: 'Press Enter or Space to inspect. Use arrow keys to move. Press Escape or Enter to close.',
  };
  const frTapZoomCopy={"en":["Tap to zoom, then drag to explore","Close zoom","Added to Bag"],"ar":["اضغط للتكبير، ثم اسحب لرؤية التفاصيل","إغلاق التكبير","أُضيف للسلة"],"cs":["Klepněte pro přiblížení a přetáhněte","Zavřít přiblížení","Přidáno"],"da":["Tryk for at zoome, og træk","Luk forstørrelse","Tilføjet"],"de":["Antippen zum Vergrößern, dann ziehen","Vergrößerung schließen","Hinzugefügt"],"el":["Πατήστε για μεγέθυνση και σύρετε","Κλείσιμο μεγέθυνσης","Προστέθηκε"],"es":["Toca para ampliar y arrastra para explorar","Cerrar ampliación","Añadido"],"fi":["Napauta zoomataksesi ja vedä","Sulje suurennus","Lisätty"],"fr":["Touchez pour agrandir, puis faites glisser","Fermer le zoom","Ajouté au panier"],"he":["הקישו להגדלה וגררו לצפייה","סגירת ההגדלה","נוסף לסל"],"hu":["Koppints a nagyításhoz, majd húzd","Nagyítás bezárása","Hozzáadva"],"it":["Tocca per ingrandire, poi trascina","Chiudi ingrandimento","Aggiunto"],"ja":["タップで拡大し、ドラッグして確認","拡大表示を閉じる","追加しました"],"nb":["Trykk for å zoome, og dra","Lukk forstørrelsen","Lagt til"],"nl":["Tik om in te zoomen en sleep","Vergroting sluiten","Toegevoegd"],"pl":["Dotknij, aby powiększyć, i przeciągnij","Zamknij powiększenie","Dodano"],"pt-PT":["Toque para ampliar e arraste","Fechar ampliação","Adicionado"],"ro":["Atinge pentru mărire, apoi glisează","Închide mărirea","Adăugat"],"sl":["Tapnite za povečavo in povlecite","Zapri povečavo","Dodano"],"sv":["Tryck för att zooma och dra","Stäng förstoringen","Tillagt"]};
  const frTapZoomLocale=function interactionLocale(language,table=frTapZoomCopy){
  const input=String(language||'en').toLowerCase();
  const base=input.split('-')[0];
  return Object.keys(table).find(key=>key.toLowerCase()===input)||({pt:'pt-PT',no:'nb'}[base])||(table[base]?base:'en');
};
  function copyFor(image) {
    const scope = image.closest('.shopify-section') || document;
    const node = scope.querySelector('[data-fr-pdp-interactions-config]') || document.querySelector('[data-fr-pdp-interactions-config]');
    let copy = {};
    try { copy = JSON.parse(node?.textContent || '{}'); } catch (_) {  }
    const localized=frTapZoomCopy[frTapZoomLocale(document.documentElement.lang||window.Shopify?.locale||'en')];
    if(typeof copy.mobileZoomHint!=='string'||!copy.mobileZoomHint.trim())copy.mobileZoomHint=localized[0];
    if(typeof copy.closeLabel!=='string'||!copy.closeLabel.trim())copy.closeLabel=localized[1];
    return Object.fromEntries(Object.entries(defaults).map(([key, fallback]) => [key, typeof copy[key] === 'string' && copy[key].trim() ? copy[key] : fallback]));
  }
  function sourceOf(image) { return image.currentSrc || image.src; }
  function startDrag(target,event){
    if(!state?.active||!state.persistent||event.button!==0)return;
    if(event.isPrimary===false){close();return;}
    event.preventDefault();
    state.drag={target,pointerId:event.pointerId,startX:event.clientX,startY:event.clientY,x:state.x,y:state.y};
    stage.classList.add('is-dragging');
    try{target.setPointerCapture(event.pointerId);}catch(_){}
  }
  function ensurePanel() {
    if (panel) return;
    panel = document.createElement('div');
    panel.id = 'fr-pdp-inspect-panel';
    panel.className = 'fr-pdp-inspect';
    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('role', 'region');
    stage = document.createElement('div'); stage.className = 'fr-pdp-inspect__stage';
    closeButton = document.createElement('button'); closeButton.type = 'button'; closeButton.className = 'fr-pdp-inspect__close'; closeButton.textContent = '×'; closeButton.hidden = true;
    closeButton.addEventListener('click', event => { event.preventDefault(); const image=state?.binding.image; close(); image?.focus({preventScroll:true}); });
    stage.addEventListener('pointerdown', event => startDrag(stage,event));
    stage.addEventListener('lostpointercapture', () => {if(state?.persistent)finishDrag();});
    panel.addEventListener('contextmenu',event=>event.preventDefault());
    panel.addEventListener('dragstart',event=>event.preventDefault());
    panel.append(stage,closeButton); document.body.appendChild(panel);
  }
  function positionOffset(token, free, scale) {
    if (['left', 'top'].includes(token)) return 0;
    if (['right', 'bottom'].includes(token)) return free;
    if (token === 'center') return free / 2;
    const terms = token.replace(/^calc\(|\)$/g, '').match(/[+-]?\s*\d*\.?\d+(?:%|px)/g);
    if (!terms) return free / 2;
    return terms.reduce((sum, term) => sum + number(term.replace(/\s/g, '')) * (term.includes('%') ? free / 100 : scale), 0);
  }
  function positionTokens(value) {
    const tokens = (value || '50% 50%').match(/calc\([^)]*\)|[^\s]+/g) || [];
    if (tokens.length >= 3) {
      const axes = { x: '50%', y: '50%' };
      for (let i = 0; i < tokens.length; i += 1) {
        const edge = tokens[i];
        if (!['left', 'right', 'top', 'bottom'].includes(edge)) continue;
        const axis = ['left', 'right'].includes(edge) ? 'x' : 'y';
        const offset = tokens[i + 1] && !/^(left|right|top|bottom|center)$/.test(tokens[i + 1]) ? tokens[++i] : '0px';
        axes[axis] = ['right', 'bottom'].includes(edge) ? `calc(100% - ${offset})` : offset;
      }
      return [axes.x, axes.y];
    }
    if (tokens.length === 1) return /^(top|bottom)$/.test(tokens[0]) ? ['50%', tokens[0]] : [tokens[0], '50%'];
    if (/^(top|bottom)$/.test(tokens[0]) || /^(left|right)$/.test(tokens[1])) tokens.reverse();
    return [tokens[0] || '50%', tokens[1] || '50%'];
  }
  function geometry(image) {
    const rect = image.getBoundingClientRect();
    if (!image.complete || !image.naturalWidth || rect.width <= 0 || rect.height <= 0) return null;
    const css = getComputedStyle(image);
    const sx = rect.width / (image.offsetWidth || rect.width);
    const sy = rect.height / (image.offsetHeight || rect.height);
    const leftInset = (number(css.borderLeftWidth) + number(css.paddingLeft)) * sx;
    const topInset = (number(css.borderTopWidth) + number(css.paddingTop)) * sy;
    const box = {
      x: rect.left + leftInset, y: rect.top + topInset,
      width: rect.width - leftInset - (number(css.borderRightWidth) + number(css.paddingRight)) * sx,
      height: rect.height - topInset - (number(css.borderBottomWidth) + number(css.paddingBottom)) * sy,
    };
    const nw = image.naturalWidth, nh = image.naturalHeight;
    if (box.width <= 0 || box.height <= 0 || !nh) return null;
    let width = box.width, height = box.height;
    if (css.objectFit !== 'fill') {
      let ratio = css.objectFit === 'cover' ? Math.max(box.width / nw, box.height / nh) : Math.min(box.width / nw, box.height / nh);
      if (css.objectFit === 'none') ratio = 1;
      if (css.objectFit === 'scale-down') ratio = Math.min(1, ratio);
      width = nw * ratio; height = nh * ratio;
    }
    const [px, py] = positionTokens(css.objectPosition);
    const x = box.x + positionOffset(px, box.width - width, sx);
    const y = box.y + positionOffset(py, box.height - height, sy);
    const visible = { x: Math.max(box.x, x), y: Math.max(box.y, y), right: Math.min(box.x + box.width, x + width), bottom: Math.min(box.y + box.height, y + height) };
    return { x, y, width, height, visible };
  }
  function pointIn(g, x, y) { return x >= g.visible.x && x <= g.visible.right && y >= g.visible.y && y <= g.visible.bottom; }
  function finishDrag() {
    const drag=state?.drag;if(!drag)return;
    state.drag=null;stage.classList.remove('is-dragging');
    try{if(drag.target.hasPointerCapture(drag.pointerId))drag.target.releasePointerCapture(drag.pointerId);}catch(_){}
  }
  function close() {
    dismissedPress = null;
    const previous = state; finishDrag(); state = null;
    if (!previous) return;
    cancelAnimationFrame(previous.frame);
    previous.loader && (previous.loader.onload = previous.loader.onerror = null);
    previous.binding.image.setAttribute('aria-expanded', 'false');
    previous.binding.wrapper.classList.remove('fr-pdp-inspect-active');
    previous.binding.wrapper.classList.remove('fr-pdp-inspect-touch-active');
    previous.binding.sample.hidden = true;
    if (previous.active && !previous.keyboard) previous.binding.suppressUntil = Date.now() + 500;
    if (panel) { panel.hidden = true; panel.setAttribute('aria-hidden','true');delete panel.dataset.inspectPersistent;stage.style.backgroundImage = '';closeButton.hidden=true; }
    try { if (previous.binding.image.hasPointerCapture(previous.pointerId)) previous.binding.image.releasePointerCapture(previous.pointerId); } catch (_) {  }
  }
  function render() {
    const current = state;
    if (!current?.active) return;
    current.frame = 0;
    const image = current.binding.image;
    if (!image.isConnected || current.source !== sourceOf(image)) { close(); return; }
    const g = geometry(image); if (!g) { close(); return; }
    const viewport = window.visualViewport;
    const vw = viewport?.width || innerWidth, vh = viewport?.height || innerHeight;
    const vx = viewport?.offsetLeft || 0, vy = viewport?.offsetTop || 0;
    const visibleSide = Math.min(g.visible.right - g.visible.x, g.visible.bottom - g.visible.y);
    const imageBox = image.getBoundingClientRect();
    const infoBox = image.closest('.fr-pdp')?.querySelector(':scope > .fr-pdp-card')?.getBoundingClientRect();
    const desktop = !current.persistent && vw >= 981 && infoBox?.width > 0 && infoBox.left >= imageBox.right - 1
      && infoBox.top < imageBox.bottom && infoBox.bottom > imageBox.top
      && Math.abs(imageBox.width - imageBox.height) < 0.1
      && imageBox.width <= visibleSide * ZOOM && infoBox.left >= vx
      && infoBox.left + imageBox.width <= vx + vw - 12;
    const side = desktop ? Math.min(imageBox.width, imageBox.height) : Math.floor(Math.min(420, vw - 24, vh / 2 - 24, visibleSide * ZOOM));
    if (side < 1) { close(); return; }
    panel.dataset.inspectMode = desktop ? 'desktop' : 'mobile';
    closeButton.hidden=!current.persistent;
    Object.assign(panel.style, { left: `${desktop ? infoBox.left : vx + (vw - side) / 2}px`, top: `${desktop ? imageBox.top : vy + vh * 0.75 - side / 2}px`, width: `${side}px`, height: `${side}px` });
    stage.style.height = `${side}px`;
    const stageBox = stage.getBoundingClientRect(), sw = stageBox.width, sh = stageBox.height;
    if (!sw || !sh) return;
    const half = Math.min(sw, sh) / (2 * ZOOM);
    const x = clamp(current.x, g.visible.x + half, g.visible.right - half), y = clamp(current.y, g.visible.y + half, g.visible.bottom - half);
    const u = clamp((x - g.x) / g.width, 0, 1), v = clamp((y - g.y) / g.height, 0, 1);
    const zoomWidth = g.width * ZOOM, zoomHeight = g.height * ZOOM;
    stage.style.backgroundSize = `${zoomWidth}px ${zoomHeight}px`;
    stage.style.backgroundPosition = `${sw / 2 - u * zoomWidth}px ${sh / 2 - v * zoomHeight}px`;
    const crop = { left: x - half, top: y - half, right: x + half, bottom: y + half };
    const wr = current.binding.wrapper.getBoundingClientRect();
    const wcss = getComputedStyle(current.binding.wrapper);
    const ww = number(wcss.width) + (wcss.boxSizing === 'border-box' ? 0 : number(wcss.paddingLeft) + number(wcss.paddingRight) + number(wcss.borderLeftWidth) + number(wcss.borderRightWidth));
    const wh = number(wcss.height) + (wcss.boxSizing === 'border-box' ? 0 : number(wcss.paddingTop) + number(wcss.paddingBottom) + number(wcss.borderTopWidth) + number(wcss.borderBottomWidth));
    const wsx = wr.width / (ww || wr.width), wsy = wr.height / (wh || wr.height);
    Object.assign(current.binding.sample.style, { left: `${(crop.left - wr.left) / wsx - number(wcss.borderLeftWidth)}px`, top: `${(crop.top - wr.top) / wsy - number(wcss.borderTopWidth)}px`, width: `${(crop.right - crop.left) / wsx}px`, height: `${(crop.bottom - crop.top) / wsy}px` });
  }
  function schedule() { if (state?.active && !state.frame) state.frame = requestAnimationFrame(render); }
  function highResolution(image, g) {
    if (image.dataset.pdpInspectSrc) return image.dataset.pdpInspectSrc;
    try {
      const url = new URL(sourceOf(image), location.href);
      if (!/\/(?:cdn\/shop|s\/files)\//.test(url.pathname) || !/^(https?:)$/.test(url.protocol)) return '';
      const width = clamp(Math.ceil(g.width * ZOOM * Math.min(devicePixelRatio || 1, 2)), 2000, 4096);
      const oldWidth = Number(url.searchParams.get('width')), oldHeight = Number(url.searchParams.get('height'));
      if (oldWidth >= width) return '';
      if (oldWidth && oldHeight) url.searchParams.set('height', String(Math.round(oldHeight * width / oldWidth)));
      url.searchParams.set('width', String(width));
      return url.href;
    } catch (_) { return ''; }
  }
  function activate() {
    const current = state; if (!current) return;
    const g = geometry(current.binding.image);
    if (!g || current.source !== sourceOf(current.binding.image) || !pointIn(g, current.x, current.y)) { close(); return; }
    ensurePanel(); current.active = true;
    panel.setAttribute('aria-hidden','false');panel.setAttribute('aria-label',current.binding.copy.zoomImageLabel);
    closeButton.setAttribute('aria-label',current.binding.copy.closeLabel);closeButton.title=current.binding.copy.closeLabel;
    if(current.persistent){panel.dataset.inspectPersistent='true';current.binding.wrapper.classList.add('fr-pdp-inspect-touch-active');current.binding.suppressUntil=Date.now()+500;}
    stage.style.backgroundImage = `url(${JSON.stringify(current.source)})`;
    panel.hidden = false; current.binding.sample.hidden = false;
    current.binding.wrapper.classList.add('fr-pdp-inspect-active');
    current.binding.image.setAttribute('aria-expanded', 'true');
    if (!current.keyboard&&!current.persistent) { try { current.binding.image.setPointerCapture(current.pointerId); } catch (_) {  } }
    render();
    const src = highResolution(current.binding.image, g);
    if (src && src !== current.source) {
      const loader = new Image(); current.loader = loader;
      loader.decoding = 'async'; loader.fetchPriority = 'low';
      loader.onload = () => { if (state === current && current.source === sourceOf(current.binding.image)) stage.style.backgroundImage = `url(${JSON.stringify(src)})`; };
      loader.onerror = () => {  };
      loader.src = src;
    }
  }
  function begin(binding, event) {
    if (event.isPrimary === false) { close(); return; }
    if (event.button !== 0 || !binding.image.complete) return;
    close(); const g = geometry(binding.image);
    if (!g || !pointIn(g, event.clientX, event.clientY)) return;
    state = { binding, pointerId: event.pointerId, pointerType: event.pointerType, x: event.clientX, y: event.clientY, startX: event.clientX, startY: event.clientY, startedAt:Date.now(), source: sourceOf(binding.image), active: false, keyboard: false };
    if (event.pointerType === 'mouse') { event.preventDefault(); activate(); }
  }
  function move(x, y, event) {
    if (!state || state.keyboard) return;
    if (!state.active && Math.hypot(x - state.startX, y - state.startY) > MOVE_LIMIT) { close(); return; }
    state.x = x; state.y = y;
    if (state.active && event?.cancelable) event.preventDefault();
    schedule();
  }
  function pan(x,y,event){
    const current=state,drag=current?.drag;if(!current?.persistent||!drag)return;
    const g=geometry(current.binding.image);if(!g){close();return;}
    const half=stage.clientWidth/(2*ZOOM);
    const scale=drag.target===stage?-1/ZOOM:1;
    current.x=clamp(drag.x+(x-drag.startX)*scale,g.visible.x+half,g.visible.right-half);
    current.y=clamp(drag.y+(y-drag.startY)*scale,g.visible.y+half,g.visible.bottom-half);
    if(event?.cancelable)event.preventDefault();schedule();
  }
  function endPointer(event,cancelled=false){
    if(!state||state.keyboard)return;
    if(state.persistent){if(state.drag?.pointerId===event.pointerId){if(cancelled)close();else finishDrag();}return;}
    if(event.pointerId!==state.pointerId)return;
    if(cancelled||state.pointerType==='mouse'){close();return;}
    if(Date.now()-state.startedAt>TAP_MS||Math.hypot(event.clientX-state.startX,event.clientY-state.startY)>MOVE_LIMIT){close();return;}
    state.x=event.clientX;state.y=event.clientY;state.persistent=true;
    if(event.cancelable)event.preventDefault();activate();
  }
  function keyboard(binding, event) {
    if (['Enter', ' '].includes(event.key)) {
      event.preventDefault(); if (event.repeat) return;
      if (state?.active && state.binding === binding) { close(); return; }
      close(); const g = geometry(binding.image); if (!g) return;
      state = { binding, keyboard: true, source: sourceOf(binding.image), x: (g.visible.x + g.visible.right) / 2, y: (g.visible.y + g.visible.bottom) / 2 };
      activate(); return;
    }
    if (!state?.active || state.binding !== binding || !state.keyboard) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    const direction = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[event.key];
    if (!direction) return;
    event.preventDefault(); const g = geometry(binding.image); if (!g) { close(); return; }
    const step = event.shiftKey ? 32 : 12;
    state.x = clamp(state.x + direction[0] * step, g.visible.x, g.visible.right);
    state.y = clamp(state.y + direction[1] * step, g.visible.y, g.visible.bottom); schedule();
  }
  function init(root = document) {
    const images = [...(root.matches?.(SELECTOR) ? [root] : []), ...root.querySelectorAll(SELECTOR)];
    images.forEach(image => {
      if (bindings.has(image)) return;
      const wrapper = image.closest('.fr-pdp-gallery__main, .fr-naked-gallery-frame'); if (!wrapper) return;
      const copy = copyFor(image), abort = new AbortController();
      const help = document.createElement('span'); help.id = `fr-pdp-inspect-help-${++sequence}`; help.className = 'fr-pdp-inspect__help'; help.textContent = copy.zoomKeyboardHint;
      const sample = document.createElement('span'); sample.className = 'fr-pdp-inspect__sample'; sample.hidden = true; sample.setAttribute('aria-hidden', 'true');
      const original = Object.fromEntries(['tabindex', 'role', 'aria-label', 'aria-describedby', 'aria-expanded', 'aria-controls','draggable'].map(name => [name, image.getAttribute(name)]));
      const zoomButton = image.closest('[data-fr-naked-zoom]');
      const originalZoomTabindex = zoomButton?.getAttribute('tabindex');
      const binding = { image, wrapper, copy, abort, help, sample, original, zoomButton, originalZoomTabindex };
      ensurePanel();
      bindings.set(image, binding); wrapper.classList.add('fr-pdp-inspect-ready'); wrapper.append(help, sample);
      image.setAttribute('tabindex', original.tabindex ?? '0'); image.setAttribute('role', original.role || 'button');
      image.setAttribute('aria-label', original['aria-label'] || `${copy.zoomImageLabel}${image.alt ? `: ${image.alt}` : ''}`);
      image.setAttribute('aria-describedby', [original['aria-describedby'], help.id].filter(Boolean).join(' '));
      image.setAttribute('aria-expanded', 'false'); image.setAttribute('aria-controls', 'fr-pdp-inspect-panel');
      image.setAttribute('draggable','false');
      const options = { signal: abort.signal };
      if (zoomButton) {
        zoomButton.setAttribute('tabindex', '-1');
        zoomButton.addEventListener('click', event => {
          event.preventDefault(); event.stopImmediatePropagation();
        }, { ...options, capture: true });
        zoomButton.addEventListener('keydown', event => {
          if (event.target === zoomButton) keyboard(binding, event);
        }, options);
      }
      image.addEventListener('pointerdown', event => begin(binding, event), options);
      image.addEventListener('keydown', event => keyboard(binding, event), options);
      image.addEventListener('blur', event => { if (state?.binding === binding&&!(state.persistent&&panel?.contains(event.relatedTarget))) close(); }, options);
      image.addEventListener('lostpointercapture', () => {if(state?.binding!==binding)return;if(state.persistent){if(state.drag?.target===image)finishDrag();}else close();}, options);
      image.addEventListener('dragstart', event => event.preventDefault(), options);
      image.addEventListener('contextmenu', event => event.preventDefault(), options);
      image.addEventListener('click', event => { if (binding.suppressUntil > Date.now()) { event.preventDefault(); event.stopImmediatePropagation(); } }, { ...options, capture: true });
      image.addEventListener('load', () => { if (state?.binding === binding) { if (state.source !== sourceOf(image)) close(); else schedule(); } }, options);
      binding.observer = new MutationObserver(() => { if (state?.binding === binding) close(); });
      binding.observer.observe(image, { attributes: true, attributeFilter: ['src', 'srcset', 'sizes'] });
    });
  }
  function destroy(root = document) {
    for (const [image, binding] of bindings) {
      if (root !== document && root !== image && !root.contains(image)) continue;
      if (state?.binding === binding) close();
      binding.abort.abort(); binding.observer.disconnect();
      if (binding.zoomButton) {
        if (binding.originalZoomTabindex == null) binding.zoomButton.removeAttribute('tabindex');
        else binding.zoomButton.setAttribute('tabindex', binding.originalZoomTabindex);
      }
      [binding.help, binding.sample].forEach(node => node.remove());
      binding.wrapper.classList.remove('fr-pdp-inspect-ready');
      Object.entries(binding.original).forEach(([name, value]) => value === null ? image.removeAttribute(name) : image.setAttribute(name, value));
      bindings.delete(image);
    }
    if(!bindings.size&&panel){panel.remove();panel=stage=closeButton=null;}
  }
  document.addEventListener('pointerdown', event => {
    dismissedPress = null;
    if (!state?.active || (!state.persistent && !state.keyboard) || panel?.contains(event.target) || event.button !== 0 || event.isPrimary === false) return;
    close();
    dismissedPress = { x: event.clientX, y: event.clientY, until: Date.now() + 800 };
    if (event.cancelable) event.preventDefault();
    event.stopImmediatePropagation();
  }, { passive: false, capture: true });
  document.addEventListener('click', event => {
    const dismissed = dismissedPress;
    dismissedPress = null;
    if (!dismissed || Date.now() > dismissed.until || Math.hypot(event.clientX - dismissed.x, event.clientY - dismissed.y) > MOVE_LIMIT) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('pointermove', event => {if(state?.persistent){if(state.drag?.pointerId===event.pointerId)pan(event.clientX,event.clientY,event);return;}if (state && !state.keyboard && event.pointerId === state.pointerId) { if (event.pointerType === 'mouse' && !event.buttons) close(); else move(event.clientX, event.clientY, event); } }, { passive: false, capture: true });
  document.addEventListener('pointerup',event=>endPointer(event),true);
  document.addEventListener('pointercancel',event=>{dismissedPress=null;endPointer(event,true);},true);
  document.addEventListener('touchstart', event => { if (event.touches.length > 1) close(); }, { passive: true, capture: true });
  document.addEventListener('touchmove', event => { if (state?.pointerType !== 'touch') return; if (event.touches.length !== 1) { close(); return; }const touch = event.touches[0];if(state.persistent){if(state.drag&&(state.drag.target===event.target||state.drag.target.contains(event.target)))pan(touch.clientX,touch.clientY,event);return;}move(touch.clientX, touch.clientY, event); }, { passive: false, capture: true });
  document.addEventListener('wheel', event => { if (state?.active && (!state.persistent||panel.contains(event.target))&&event.cancelable) event.preventDefault(); }, { passive: false, capture: true });
  document.addEventListener('touchcancel',()=>{if(state?.pointerType==='touch')close();},{passive:true,capture:true});
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && state) { event.preventDefault(); close(); } }, true);
  document.addEventListener('visibilitychange', () => { if (document.hidden) close(); });
  window.addEventListener('blur', close); window.addEventListener('resize', close);
  window.addEventListener('pagehide', close);
  window.addEventListener('scroll', () => { if (state && (!state.active||state.persistent)) close(); else schedule(); }, { passive: true });
  window.visualViewport?.addEventListener('resize', close);
  window.visualViewport?.addEventListener('scroll', schedule);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  window.FrilloraPdpInspect = { init, close, destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
